import * as React from "react";
import { useState, useRef, useEffect } from "react";
import BaseModelMap from "../models/BaseModelMap";
import Cabinet from "../models/Cabinet";
import BaseDialog, { Field, FieldSet } from "./BaseDialog";
import { showToast } from "../components/Toasts";

import Floor from "../models/Floor";
import Logger from "../Logger";
import Room from "../models/Room";
import { itx } from "../translationItx/itx";
import { EventKey } from "../eventLogger/EventKeys";

const logger = new Logger();

export default function CabinetDialog(props: {
  parent?: BaseModelMap<Cabinet>;
  obj?: Cabinet;
  floorRoom?: Floor | Room;
  afterCreation?: () => boolean;
}) {
  const { parent, floorRoom, afterCreation } = props;
  var { obj } = props;

  const [tag, setTag] = useState(obj?.tag || getNewCabinTag());
  const [name, setName] = useState(obj?.name || getNewCabinetName());
  const tagIsSetManual = useRef<boolean>(false);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const tagInputRef = useRef<HTMLInputElement>(null);

  const edit = obj != undefined;

  useEffect(() => {
    setTimeout(() => {
      if (nameInputRef.current) {
        nameInputRef.current?.focus();
      }
    }, 100);
  }, []);

  if (!edit && parent == undefined) {
    logger.error("parent == undefined");
  }

  // check if name is already assingned
  function checkValidName(name: string): boolean {
    var double = false;

    parent?.items.forEach((cabinet) => {
      if (state.noDoubleValue.ciEquals(cabinet.name, name)) {
        double = true;
      }
    });

    return !double;
  }

  function getNewCabinetName(): string {
    var cabinetName = state.translate("components.Cabinet", "Schaltschrank ");
    if (tag == "") {
      return "";
    }
    var i = 1;
    var newCabinetName = cabinetName + i;
    while (!checkValidName(newCabinetName)) {
      newCabinetName = cabinetName + i;
      i++;
    }

    return newCabinetName;
  }

  function getNewCabinTag(): string {
    return state.nameAndTagManager.generateTag(new Cabinet({ isTemporary: true }, parent));
  }

  function createNewCabinet(): boolean {
    //check if tag is doubl
    const listAllCabinetsTags = new Array<string>();
    state.cabinets.forEach((cabinet) => {
      listAllCabinetsTags.push(cabinet.tag);
    });
    if (edit) {
    } else {
      if (!listAllCabinetsTags.includes(tag)) {
        let tagFromInput = (document.getElementById("CabinetDialog_tag") as HTMLInputElement)?.value;
        if (!tagFromInput) {
          tagFromInput = tag;
        }
        let nameFromInput = (document.getElementById("CabinetDialog_name") as HTMLInputElement)?.value;
        if (!nameFromInput) {
          nameFromInput = name;
        }
        const newCabinet = new Cabinet({ name: nameFromInput, tag: tagFromInput }, parent);
        if ((document.getElementById("CabinetDialog_tag") as HTMLInputElement)?.value) {
          newCabinet.tag = tagFromInput.toUpperCase();
        } else {
          newCabinet.tag = state.nameAndTagManager.generateTag(newCabinet);
        }

        parent?.add(newCabinet);

        state.eventLogger.addEvent(EventKey.ObjectCreated, {
          objectType: "Cabinet",
          obj: newCabinet.id + "_" + newCabinet.tag + "_" + newCabinet.name,
        });
        if (floorRoom) {
          floorRoom.cabinetId = newCabinet.id;
          floorRoom.raiseOnChange("cabinetId");
        }
        obj = newCabinet;
        state.selectionManager.selectedObject = newCabinet;
        if (afterCreation) {
          return afterCreation();
        }
      } else {
        //setTag(getNewCabinTag());//doesn`t get new Render
        showToast({
          text: state.translate(
            "cabinetDialog.tagAlreadyInOtherCabinet",
            `Ihr eingegebener Tag ist schon an deinem anderen Cabinet vergeben bitte ändern Sie diesen`,
          ),
        });
        return false;
      }
    }
    return true;
  }

  return (
    <BaseDialog
      title={
        edit
          ? state.translate("cabinetDialog.editCabinet", "Schaltschrank bearbeiten")
          : state.translate("cabinetDialog.createNewCabinet", "Neuen Schaltschrank anlegen")
      }
      onClose={() => {
        return true;
      }}
      onOk={() => {
        return createNewCabinet();
      }}
    >
      <FieldSet>
        <Field label={state.translate("tag", "Tag")}>
          <input
            id="CabinetDialog_tag"
            className="input"
            ref={tagInputRef}
            maxLength={state.maxCharLimit.tag}
            defaultValue={tag}
            onChange={(ev) => {
              const v = ev.target.value.toLocaleUpperCase().trim();
              ev.target.value = v;
              setTag(v);
              tagIsSetManual.current = true;
            }}
          ></input>
        </Field>
        <Field label={state.translate("name", "Name")}>
          <input
            id="CabinetDialog_name"
            className="input"
            ref={nameInputRef}
            maxLength={state.maxCharLimit.text}
            defaultValue={name}
            placeholder={itx("floorCreateAskBack.mainCabinet", "Hauptschaltschrank")}
            onChange={(ev) => {
              setName(ev.target.value);
            }}
            onInput={(ev) => {
              const choosenName = ev.currentTarget.value;

              if (!tagIsSetManual.current || tag == "") {
                const dummyCabinet = new Cabinet({ isTemporary: true }, state.cabinets);
                state.cabinets.addWithoutUpdate(dummyCabinet);
                dummyCabinet.name = choosenName;
                dummyCabinet.generateTagFromName();

                const tag = dummyCabinet.tag;
                if (tagInputRef.current) {
                  tagInputRef.current.value = tag;
                }

                state.cabinets.removeWithoutUpdate(dummyCabinet);
              }
            }}
          ></input>
        </Field>
      </FieldSet>
    </BaseDialog>
  );
}
